// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.darkblue{
    background: rgb(105, 105, 238);
    min-height: 100vh;
    min-width: 100vw;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;AAChC","sourcesContent":["\n.darkblue{\n    background: rgb(105, 105, 238);\n    min-height: 100vh;\n    min-width: 100vw;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
